import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

const MenuButtonSaveMap = (props) => {
    const map = useMapContext()
    const handleClick = () => map.commands.saveMap()

    return (
        <MenuButton
            onClick={handleClick}
            {...props}
        >
            保存地图
        </MenuButton>
    )
}

export default MenuButtonSaveMap
